import React from 'react'
import createUsePollingWithCache from 'hooks/createUsePollingWithCache'
import { getData as apiGetData } from 'api/Api'

type BoardNamesData = {
  Boards: {
    Id: number
    Name: string
  }[]
}

const usePollingWithCache = createUsePollingWithCache<string | null>({
  getData: (ids, setData) => {
    apiGetData('BoardNames', { ids }).then((data: BoardNamesData) => {
      ids.forEach(id => setData(id, (data.Boards.find(Board => Board.Id === Number(id)) || { Name: null }).Name))  
    })
  }
})

type RenderData = {
  name: string | null | undefined
  error?: any
  isLoading: boolean
}

type Props = {
  children?: (data: RenderData) => React.ReactNode

  id: number
}

const BoardName: React.FC<Props> = ({
  children,

  id,
}) => {
  const name = usePollingWithCache(String(id))

  if (children) return children({
    name,
    isLoading: false,
  })

  return (name as any) || null
}

export default BoardName
